import { Route } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';

export const ShopRoutes: Route[] = [
  {
    path: 'shop',
    loadComponent: () => import('../layout/shop-laytout/shop.layout'),
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        data: { title: '서비스 상점 대시보드' },
        loadComponent: () =>
          import('../pages/shop/shop-dashboard/shop-dashboard.page'),
      },
      {
        path: 'products',
        data: { title: '서비스 상품 관리' },
        loadComponent: () =>
          import('../pages/shop/shop-product/shop-product.page'),
      },
      {
        path: 'products/new',
        data: { title: '서비스 상품 등록' },
        loadComponent: () =>
          import('../pages/shop/shop-product-form/shop-product-form.page'),
      },
      {
        path: 'products/:id',
        data: { title: '서비스 상품 상세' },
        loadComponent: () =>
          import('../pages/shop/shop-product-detail/shop-product-detail.page'),
      },
      {
        path: 'products/:id/edit',
        data: { title: '서비스 상품 수정' },
        loadComponent: () =>
          import('../pages/shop/shop-product-form/shop-product-form.page'),
      },
      {
        path: 'orders',
        data: { title: '주문 관리' },
        loadComponent: () =>
          import('../pages/shop/shop-payment/shop-payment.page'),
      },
    ],
  },
];
